

















import { createComponent } from "@vue/composition-api";
import ResourceItemTable from "@/components/resource/ResourceItemTable.vue";
import { czescBudynkuResource } from "@megarax/client/src/resources/plm";

export default createComponent({
  components: { ResourceItemTable },
  setup(props, ctx) {
    return {
      resource: czescBudynkuResource,
    };
  },
});
